import { FC, useState, useEffect } from "react";
import { Button, Radio, Select, Checkbox, DatePicker, notification , Input} from "antd";
import { CloseOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { isNaN, isUndefined, isEmpty, noop } from "lodash";
import moment from "moment";
import classnames from "classnames";

import "./popUp.scss";
import CommonModal from "../component/modal/modal";
import memberDetailService from "@services/memberDetails.service";
import membersService from "@services/members.service";
import TextAreaComp from "@components/textArea";
import {
  CASE_STATUS_REASON_FOLLOW_UP,
  CASE_STATUS_REASON_GRADUATED,
  CASE_STATUS_REASON_DECLINED,
  CASE_STATUS_REASON_EXTERNAL,
  MEMBER_DETAILS_CASE_STATUS_ACTIVE,
  MEMBER_DETAILS_CASE_STATUS_FOLLOW_UP,
  MEMBER_DETAILS_CASE_STATUS_GRADUATED,
  MEMBER_DETAILS_CASE_STATUS_DECLINED,
  MEMBER_DETAILS_CASE_STATUS_EXTERNAL,
  USER_ACTION_MODULE_MEMBER_DETAIL,
  USER_ACTION_TAB_MEMBER_PROFILE_HEADER,
  USER_ACTION_CARD_MEMBER_PROFILE_RADIO,
  USER_ACTION_LOCATION_ACTIVE,
  USER_ACTION_LOCATION_FOLLOW_UP,
  USER_ACTION_LOCATION_GRADUATED,
  USER_ACTION_LOCATION_DECLINED,
  USER_ACTION_LOCATION_EXTERNAL,
  USER_ACTION_DESCRIPTION_STATUS_CHANGE,
  MEMBER_DETAILS_FOLLOWUP_REMINDER,
  CASE_STATUS_ACTIVE,
  CASE_STATUS_FOLLOW_UP,
  CASE_STATUS_GRADUATED,
  CASE_STATUS_DECLINED,
  CASE_STATUS_EXTERNAL,
} from "@utils/constants";

import { getInputTime, getNoteMaxLength, getReminderMaxLength, localToUTCFormatDate } from "@utils/helpers";
import TimingDropdown from "@components/time-dropdown";
import RichTextEditorComp from "@components/richTextEditor/richText";
import RichTextEditor from "@components/richTextEditor";
import Icon from "@assets/icon_config";

const PatientCaseStatusPopUp: FC<any> = (props) => {
  const currentMember = membersService.getCurrentMember;

  const USER_REASON_DEFAULT_SELECTED_OPTION = "Hospital Utilization";
  const { Option } = Select;
  const { onStatusChange, patientCaseStatusOptions } = props;

  const [patientCaseStatus, setPatientCaseStatus] = useState<any>(currentMember?.patient_case_status);

  useEffect(() => {
    setPatientCaseStatus(currentMember?.patient_case_status);
  }, [currentMember?.patient_case_status]);

  //Patient Case status modal visibility flag
  const [patientCaseStatusData, setPatientCaseStatusData] = useState<any>({ open: false, case: null, title: "", children: <></>, closable: false });
  const [activeStatusReasonDropDownOptions, setActiveStatusReasonDropDownOptions] = useState<any>(null);
  const [activeCaseStatusData, setActiveCaseStatusData] = useState<any>({ reason: USER_REASON_DEFAULT_SELECTED_OPTION, note: "" });

  useEffect(() => {
    getActiveCaseStatusDropDown();
  }, []);

  const getActiveCaseStatusDropDown = () => {
    memberDetailService.fetchCaseStatusActiveDropdown("StatusChangeReasonLst").subscribe({
      next: (response: any) => {
        setActiveStatusReasonDropDownOptions(response.data.data.data);
      },
      error: (error) => {
        console.log(error);
      },
    });
  };

  const onStatusOptionChange = (e: any) => {
    setPatientCaseStatusData({ ...patientCaseStatusData, open: true, case: e.target.value, children: caseStatusDOM(e.target.value) });
  };

  const onPatientCaseStatusOnApply = () => {
    setPatientCaseStatusData({ ...patientCaseStatusData, open: false });
    console.log("PatientCase status change");
  };

  const onPatientCaseStatusOnCancel = () => {
    setPatientCaseStatusData({ ...patientCaseStatusData, open: false });
    setActiveCaseStatusData({ reason: null, note: "" });
    console.log("PatientCase status cancel");
  };

  const addNote = (note: any, noteType: any, noteCallBack: any) => {
    membersService.addNotes([currentMember?.patient_id], note, noteType).subscribe({
      next: (res) => {
        // if (patientStatus === "New") membersService.updateStatus(patientId, "Active").subscribe();
        noteCallBack();
        console.log(res?.data?.data?.note[0]);
      },
      error: () => {},
    });
  };

  const reminderSaveHandler = (data: any, callBack: any) => {
    const { reminderDate, timeInput1, timeInput2, noteContent , reminderTitle} = data;

    const from = `${reminderDate?.format("YYYY-MM-DD")} ${timeInput1}:00`;
    const to = `${reminderDate?.format("YYYY-MM-DD")} ${timeInput2}:00`;

    const _from = new Date(from);
    const _to = new Date(to);

    if (_to <= _from || isUndefined(timeInput1) || isUndefined(timeInput2)) {
      notification.error({
        message: "Error",
        description: isUndefined(timeInput1) || isUndefined(timeInput2) ? "Please fill time." : "Please enter proper time range.",
      });
    } else if (moment(from, "YYYY-MM-DD HH:mm").add(1, "m") < moment()) {
      notification.error({
        message: "Error",
        description: "Reminders for past time cannot be added. Please enter proper time range.",
      });
    } else if (isEmpty(noteContent) || isUndefined(noteContent)) {
      notification.error({
        message: "Error",
        description: "Please add content.",
      });
    } else {
      membersService
        .addReminder(
          currentMember?.patient_id,
          localToUTCFormatDate(from),
          localToUTCFormatDate(to),
          noteContent,
          null,
          {
            reminderType: MEMBER_DETAILS_FOLLOWUP_REMINDER,
          },
          currentMember?.patient_name,
          reminderTitle
        )
        .subscribe({
          next: (res: any) => {
            callBack();
          },
          error: (err: any) => {
            console.log(err, "error");
          },
        });
    }
  };

  const FollowUpPopUp = ({ onStatusChange, addNote, action_status }: any) => {
    const initialState = {
      checked: true,
      reminderSelect: "7",
      noteContent: "",
      reminderTitle : '',
      reminderDate: moment().add(7, "days"),
      timeInput1: getInputTime(),
      timeInput2: getInputTime(15),
    };

    const [followUpData, setFollowUpData] = useState<any>(initialState);
    const followUpReminderDateChange = (val: any) => {
      setFollowUpData({ ...followUpData, reminderDate: val });
    };

    const followUpSelectChange = (val: any) => {
      setFollowUpData({ ...followUpData, reminderSelect: val, ...{ reminderDate: isNaN(val) ? undefined : val === "Custom" ? moment().add(1, "days") : moment().add(val, "days") } });
    };

    const followUpTimeChange = (val: string, inputName: string) => {
      if (inputName === "timeInput1") {
        setFollowUpData({ ...followUpData, [inputName]: val, timeInput2: moment(val, "HH:mm").add(15, "m").format("HH:mm") });
      } else {
        setFollowUpData({ ...followUpData, [inputName]: val });
      }
    };


    const getCaseStatusReason = (actionStatus : string) => {
        let reasons : any = {
          "Follow Up" : CASE_STATUS_REASON_FOLLOW_UP,
          "Graduated" : CASE_STATUS_REASON_GRADUATED,
          "Declined" : CASE_STATUS_REASON_DECLINED,
          "External" : CASE_STATUS_REASON_EXTERNAL
        }

        return reasons[actionStatus] || reasons['External'];
    }

    const getActionLocation = (actionStatus : string = '') => {
      let actionLocation : any = {
        "Follow Up" : USER_ACTION_LOCATION_FOLLOW_UP,
        "Graduated" : USER_ACTION_LOCATION_GRADUATED,
        "Declined" : USER_ACTION_LOCATION_DECLINED,
        "External" : USER_ACTION_LOCATION_EXTERNAL
      }

      return actionLocation[actionStatus] || actionLocation['External'];
    }

    const getNoteType = (actionStatus: string = '') => {
      let noteTypes: any = {
        "Follow Up" : MEMBER_DETAILS_CASE_STATUS_FOLLOW_UP,
        "Graduated" : MEMBER_DETAILS_CASE_STATUS_GRADUATED,
        "Declined" : MEMBER_DETAILS_CASE_STATUS_DECLINED,
        "External" : MEMBER_DETAILS_CASE_STATUS_EXTERNAL
      }
      return noteTypes[actionStatus] || noteTypes['External'];
    }

    const statusChangeCallBack = () => {
      setPatientCaseStatusData({ ...patientCaseStatusData, open: false });
      onStatusChange(
        action_status,
        getCaseStatusReason(action_status),
        USER_ACTION_MODULE_MEMBER_DETAIL,
        USER_ACTION_TAB_MEMBER_PROFILE_HEADER,
        USER_ACTION_CARD_MEMBER_PROFILE_RADIO,
        getActionLocation(action_status),
        USER_ACTION_DESCRIPTION_STATUS_CHANGE,
        () => noop()
      );
      setFollowUpData(initialState);
    }

    const handleSubmit = () => {
      if (action_status === "Follow Up") {
        if (!followUpData.checked) {
          if (followUpData.noteContent) {
            addNote(followUpData.noteContent, getNoteType(action_status), statusChangeCallBack);
          } else {
            statusChangeCallBack()
          }
        } else {
          // addNote(followUpData.noteContent , MEMBER_DETAILS_CASE_STATUS_FOLLOW_UP);
          reminderSaveHandler(followUpData, statusChangeCallBack);
        }
      } else {
        if (followUpData.noteContent) {
          addNote(
            followUpData.noteContent,
            getNoteType(action_status),
            statusChangeCallBack
          );
        }
      }
    };
    const followUpDataNoteContentLength = followUpData.noteContent.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim().length;
    const notesWordLimit = followUpData.checked && action_status === "Follow Up" ? getReminderMaxLength() : getNoteMaxLength()
    const _reminderClassName = classnames("caseStatus-common-reminder", { dnone: !followUpData.checked });
    const _starClassName = classnames("clr-e100", { dnone: !followUpData.checked });

    function disableSubmitButton() : boolean | undefined {
      const {checked , reminderSelect , reminderDate , timeInput1 , timeInput2 } = followUpData;
      if(checked) {
        return !(reminderSelect && reminderDate && timeInput1 && timeInput2 && followUpDataNoteContentLength && followUpDataNoteContentLength <= notesWordLimit);
      } else {
        return !(followUpDataNoteContentLength <= notesWordLimit)
      }
    } 
    
    return (
      <div className="patientStatus activeCaseStatus">
        <div className="caseStatus-common__header">
          <div className="caseStatus-common__header__title">{action_status}</div>
          <div className="caseStatus-common__header__close" onClick={() => onPatientCaseStatusOnCancel()}>
            <CloseOutlined />
          </div>
        </div>
        <div className="activeCaseStatus__body">
          {action_status === "Follow Up" ? (
            <>
              <div className="caseStatus-common__checkbox">
                <Checkbox checked={followUpData.checked} onChange={(e) => setFollowUpData({ ...followUpData, checked: e.target.checked })}>
                  <span style={{ color: "#7A869A", fontSize: "16px" }}>
                    Create a <span style={{ color: "#42526E", fontWeight: "500" }}>reminder</span> to follow-up with the patient.
                  </span>
                </Checkbox>
              </div>
              <div className={_reminderClassName}>
                <ClockCircleOutlined className="caseStatus-common-reminder__icon" />
                <Select
                  className="caseStatus-common-reminder__select"
                  style={{ width: "8rem" }}
                  showSearch
                  dropdownMatchSelectWidth={false}
                  optionFilterProp="children"
                  onChange={(e: any) => followUpSelectChange(e)}
                  filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  value={followUpData.reminderSelect}
                  options={[
                    {
                      value: "7",
                      label: "7 days later",
                    },
                    {
                      value: "30",
                      label: "30 days later",
                    },
                    {
                      value: "90",
                      label: "90 days later",
                    },
                    {
                      value: "Custom",
                      label: "Custom",
                    },
                  ]}
                />
                <DatePicker
                  onChange={(val) => followUpReminderDateChange(val)}
                  format="MM-DD-YYYY"
                  className={"reminderCal caseStatus-common-reminder__date"}
                  dropdownClassName={"remCal"}
                  value={followUpData.reminderDate}
                  defaultValue={followUpData.reminderDate}
                  disabled={followUpData.reminderSelect !== "Custom"}
                  allowClear={false}
                  disabledDate={(current) => current && current.valueOf() <= Date.now()}
                />
                <TimingDropdown value={followUpData.timeInput1} onChange={(val: string) => followUpTimeChange(val, "timeInput1")} date={followUpData.reminderDate?.format("YYYY-MM-DD")} />
                <span style={{ color: "#0072E3", display: "flex", alignSelf: "center", cursor: "not-allowed" }}>-</span>
                <TimingDropdown
                  value={followUpData?.timeInput2}
                  onChange={(val: string) => followUpTimeChange(val, "timeInput2")}
                  isToDate={true}
                  date={followUpData?.reminderDate?.format("YYYY-MM-DD")}
                  refreshToTime={followUpData?.timeInput1}
                  fromTime={followUpData?.timeInput1}
                />
              </div>
              <div className="reminderCal caseStatus-common-reminder__title">
                <Icon name="title" />
                <div className="reminderCal caseStatus-common-reminder__title--input">
                  <Input
                    placeholder="Enter Title"
                    value={followUpData?.reminderTitle}
                    disabled={false}
                    onChange={(e) =>
                      setFollowUpData({
                        ...followUpData,
                        reminderTitle: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </>
          ) : (
            <></>
          )}

          <div className="activeCaseStatus__body__container1">
            <div className="activeCaseStatus__body__container1__title">
              Note<span className={_starClassName}>*</span>
            </div>
            <div className="activeCaseStatus__body__container1__text">
              {followUpData.checked && action_status === "Follow Up" ? (
                <TextAreaComp
                  content={followUpData.noteContent}
                  changeHandler={(e: any) => {
                    setFollowUpData({ ...followUpData, noteContent: e });
                  }}
                  actionsMenu={false}
                  autoFocus={true}
                  showCount={true}
                  wordLimit={getReminderMaxLength()}
                />
              ) : (
                <RichTextEditor
                  content={followUpData.noteContent}
                  changeHandler={(e: any) => {
                    setFollowUpData({ ...followUpData, noteContent: e });
                  }}
                  actionsMenu={false}
                  autoFocus={true}
                  showCount={true}
                  wordLimit={getNoteMaxLength()}
                />
              )}
            </div>
          </div>
          <div className="caseStatus-common__footer">
            <div className="caseStatus-common__footer__cancel">
              <Button
                onClick={() => {
                  setFollowUpData(initialState);
                  onPatientCaseStatusOnCancel();
                }}
              >
                Cancel
              </Button>
            </div>
            <div className="caseStatus-common__footer__submit">
              <Button type="primary" onClick={() => handleSubmit()} disabled={disableSubmitButton()}>
                Submit
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const caseStatusDOM = (option: any) => {
    let result = patientCaseStatusOptions.find((item:any) => item?.value === option)
    switch (result?.value) {
      case "Active":
        return <ActiveCaseStatus />;
      default:
        return <FollowUpPopUp onStatusChange={onStatusChange} addNote={addNote} action_status={result?.value} />;
    }
  };

  const onActiveStatusSubmit = (reason: any, note: any, patientCase: string) => {
    setActiveCaseStatusData({
      reason: reason,
      note: note,
    });
    if (note !== "")
      addNote(note, MEMBER_DETAILS_CASE_STATUS_ACTIVE, () => {
        setPatientCaseStatusData({ ...patientCaseStatusData, open: false });
        onStatusChange(
          patientCase,
          reason,
          USER_ACTION_MODULE_MEMBER_DETAIL,
          USER_ACTION_TAB_MEMBER_PROFILE_HEADER,
          USER_ACTION_CARD_MEMBER_PROFILE_RADIO,
          USER_ACTION_LOCATION_ACTIVE,
          USER_ACTION_DESCRIPTION_STATUS_CHANGE,
          () => noop()
        );
      });
    else {
      setPatientCaseStatusData({ ...patientCaseStatusData, open: false });
      onStatusChange(
        patientCase,
        reason,
        USER_ACTION_MODULE_MEMBER_DETAIL,
        USER_ACTION_TAB_MEMBER_PROFILE_HEADER,
        USER_ACTION_CARD_MEMBER_PROFILE_RADIO,
        USER_ACTION_LOCATION_ACTIVE,
        USER_ACTION_DESCRIPTION_STATUS_CHANGE,
        () => noop()
      );
    }
  };

  const ActiveCaseStatus = () => {
    const [option, setOption] = useState<any>(activeCaseStatusData.reason);
    const [note, setNote] = useState<any>(activeCaseStatusData.note);
    const noteLength = note.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim().length; 
    return (
      <div className="activeCaseStatus">
        <div className="caseStatus-common__header">
          <div className="caseStatus-common__header__title">Active Reason</div>
          <div className="caseStatus-common__header__close" onClick={() => onPatientCaseStatusOnCancel()}>
            <CloseOutlined />
          </div>
        </div>
        <div className="activeCaseStatus__body">
          <div className="activeCaseStatus__body__reason">
            <div className="activeCaseStatus__body__reason__label">Reason{!option ? <span className="activeCaseStatus__body__container1__title__mandatory">*</span> : null}</div>
            <div className="activeCaseStatus__body__reason__dropDown">
              <Select
                value={option}
                onChange={(value) => {
                  setOption(value);
                }}
              >
                {activeStatusReasonDropDownOptions.map((item: any, index: any) => {
                  return (
                    <Option value={item.value} key={item.value + index}>
                      {item.value}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>
          <div className="activeCaseStatus__body__container1">
            <div className="activeCaseStatus__body__container1__title">Note{option === "Other" ? <span className="activeCaseStatus__body__container1__title__mandatory">*</span> : null}</div>
            <div className="activeCaseStatus__body__container1__text">
              <RichTextEditor
                content={note}
                changeHandler={(text: any) => {
                  setNote(text);
                }}
                actionsMenu={false}
                autoFocus={true}
                showCount={true}
                wordLimit={getNoteMaxLength()}
              />
            </div>
          </div>
          <div className="caseStatus-common__footer">
            <div className="caseStatus-common__footer__cancel">
              <Button onClick={() => onPatientCaseStatusOnCancel()}>Cancel</Button>
            </div>
            <div className="caseStatus-common__footer__submit">
              <Button type="primary" disabled={(option === "Other" && !noteLength) || (!option)} onClick={() => onActiveStatusSubmit(option, note, "Active")}>
                Submit
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <span className="radio-btn">
        <Radio.Group onChange={(e) => onStatusOptionChange(e)} value={patientCaseStatus}>
          {patientCaseStatusOptions?.map((item: any) => {
            return (item.value === "New"?<></>:<Radio value={item.value} disabled={item.isDisabled === 'true'}>{item.label}</Radio>);
          })}
        </Radio.Group>
      </span>
      <CommonModal
        open={patientCaseStatusData.open}
        closable={patientCaseStatusData.closable}
        onOk={onPatientCaseStatusOnApply}
        onCancel={onPatientCaseStatusOnCancel}
        children={patientCaseStatusData.children}
      />
    </>
  );
};

export default PatientCaseStatusPopUp;
